
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import ImageBase from '@/components/atoms/ImageBase.vue'
import RoundSelect from '@/components/molecules/RoundSelect.vue'
import ManageSidemenuLayout from '@/components/organisms/layout/ManageSidemenuLayout.vue'
import StudentPersonalProgressPanel from '@/components/organisms/manage/StudentPersonalProgressPanel.vue'
import LearningChart from '@/components/organisms/LearningChart.vue'
import { SelectItem } from '@/models/SelectItem'
import { SystemChartDetail } from '@/models/SystemChart'

/**
 * 生徒毎の知識マップ学習進捗確認
 */
@Component({
  components: {
    ButtonBase,
    ImageBase,
    RoundSelect,
    ManageSidemenuLayout,
    StudentPersonalProgressPanel,
    LearningChart,
  },
})
export default class StudentPersonalLearningMapProgress extends Vue {
  /** 教科プルダウン */
  @Ref()
  subjectFilter!: RoundSelect

  /** 系統図プルダウン */
  @Ref()
  mapFilter!: RoundSelect

  /** 塾管理者権限画面の場合true */
  @Prop({ default: false })
  private isAcademy!: boolean

  /** 先生権限画面の場合true */
  @Prop({ default: false })
  private isTeacher!: boolean

  /** 生徒ニックネーム */
  @Prop()
  private studentName!: string

  /** 教科プルダウンの選択肢 */
  @Prop()
  private filterSubjectList!: SelectItem[]

  /** 教科プルダウンの初期値 */
  @Prop()
  private defaultSubjectCode!: string

  /** 系統図プルダウンの選択肢 */
  @Prop()
  private filterMapList!: SelectItem[]

  /** 系統図プルダウンの初期値 */
  @Prop()
  private defaultMapId: string | undefined

  /** 系統図プルダウンのDisabled制御 */
  @Prop()
  private isDisabledMapFilter!: boolean

  /** 知識MAP詳細情報 */
  @Prop()
  private systemChartDetail!: SystemChartDetail | null

  /** 生徒学習進捗タブクリック時のイベント */
  @Prop()
  private eventClickStudentProgressTab!: () => void

  /** 戻るボタン押下時のイベント */
  @Prop()
  private eventClickBackButton!: () => void

  /** 教科プルダウン変更時のイベント */
  @Prop()
  private changeSubjectFilter!: () => void

  /** 系統図プルダウン変更時のイベント */
  @Prop()
  private changeMapFilter!: () => void

  /** 単元選択時のイベント */
  @Prop()
  private onSelectUnit!: (id: number) => void

  /**
   * 選択中の教科コード取得
   *
   * @returns 選択中の教科コード
   */
  public get selectedSubjectCode(): string {
    return this.subjectFilter.selectedValue()
  }

  /**
   * 選択中の系統図ID取得
   *
   * @returns 選択中の系統図ID
   */
  public get selectedMapId(): number {
    return Number(this.mapFilter.selectedValue())
  }
}
